import { useState } from "react";
import { Loader2, MailPlus, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { ROLE, fmtDate } from "../../lib/labels";
import AccessFields, { emptyAccess } from "./AccessFields";

export default function InvitationsPanel({ meta, agencies, services }) {
  const { data, reload } = useApi("/company/invitations");
  const [email, setEmail] = useState("");
  const [access, setAccess] = useState(emptyAccess());
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { toast.error("Email invalide"); return; }
    setBusy(true);
    try { await api.post("/company/invitations", { email, ...access }); toast.success("Invitation envoyée par email"); setEmail(""); setAccess(emptyAccess()); reload(); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  const revoke = async (id) => {
    try { await api.delete(`/company/invitations/${id}`); toast.success("Invitation annulée"); reload(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="card-surface mt-8 p-5" data-testid="invitations-panel">
      <p className="font-display font-semibold">Inviter par email</p>
      <p className="mt-1 text-sm text-slate-500">La personne rejoint votre espace avec son compte existant ou en crée un, avec le rôle et les accès définis ci-dessous.</p>
      <form onSubmit={send} className="mt-4 space-y-4">
        <Input type="email" placeholder="email@exemple.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="invite-email-input" />
        <AccessFields value={access} onChange={setAccess} meta={meta} agencies={agencies} services={services} />
        <Button type="submit" disabled={busy} data-testid="invite-submit-button">{busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <MailPlus className="mr-1.5 h-4 w-4" />}Envoyer l'invitation</Button>
      </form>
      {data?.length > 0 && (
        <div className="mt-5 divide-y border-t">
          {data.map((i) => (
            <div key={i.id} className="flex items-center gap-2 py-2.5 text-sm" data-testid={`invitation-${i.id}`}>
              <span className="flex-1">{i.email} · {ROLE[i.role]} <span className="text-xs text-slate-400">· envoyée le {fmtDate(i.created_at, false)}</span></span>
              <Button variant="ghost" size="sm" onClick={() => revoke(i.id)} data-testid={`invitation-revoke-${i.id}`}><X className="h-4 w-4" /></Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
